module.exports = __webpack_public_path__ + "static/informes-4a8171b3109962b49f04423cbc06097b.jpg";